import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Book, Gamepad2, Palette, Star, Lock } from "lucide-react";
import { useApp } from "../context";
import { isAdminUser } from "../utils/adminCheck";

const MobileBottomNav = () => {
  const location = useLocation();
  const { user } = useApp();
  const isActive = (path) => location.pathname === path || (path !== "/" && location.pathname.startsWith(path));

  return (
    <nav className="mobile-nav-universe md:hidden" data-testid="mobile-bottom-nav">
      {[
        { to: "/", icon: Home, label: "Home", exact: true },
        { to: "/learn", icon: Book, label: "Learn" },
        { to: "/arcade", icon: Gamepad2, label: "Arcade" },
        { to: "/art-studio", icon: Palette, label: "Art Studio" },
        { to: "/my-world", icon: Star, label: "Dashboard" },
      ].map((item) => {
        const active = item.exact ? location.pathname === item.to : isActive(item.to);
        const blocked = item.comingSoon && !isAdminUser(user);
        if (blocked) {
          return (
            <div key={item.to} className="mobile-nav-item opacity-30 cursor-not-allowed" data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <item.icon size={20} />
              <span className="text-[8px]">Soon</span>
            </div>
          );
        }
        return (
          <Link key={item.to} to={item.to} className={`mobile-nav-item ${active ? "active" : ""}`} data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
            <item.icon size={20} />
            <span>{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default MobileBottomNav;
